import React from 'react';

import { Checkbox } from '@lightspeed/flame/Checkbox';
import { Box, flameTheme, Flex } from '@lightspeed/flame/Core';
import { Divider } from '@lightspeed/flame/Divider';
import { Text } from '@lightspeed/flame/Text';

import { sanitizeText } from 'pages/utils/sanitize';

type SerialNumberRowProps = {
  serializedId: number;
  serial: string;
  isSelected: boolean;
  isRefunded: boolean;
  onCheckClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const SerialNumberRow: React.FC<SerialNumberRowProps> = ({
  serializedId,
  serial,
  isSelected,
  isRefunded,
  onCheckClick,
}) => {
  const { colors } = flameTheme;

  return (
    <>
      <Flex alignItems="center" data-test="serial-number-row" className="serial-number-row">
        <Box flex="0 0 auto" pl={3} py={3}>
          <Checkbox
            id={`serial-number-row-checkbox-${serializedId}`}
            data-test="serial-number-row-checkbox"
            checked={isSelected}
            disabled={isRefunded}
            onChange={onCheckClick}
          />
        </Box>
        <Flex
          width="75%"
          fontSize="0.875rem"
          color={isRefunded ? '#8B939B' : colors.textBody}
          pr={2}
          py={2}
        >
          <Text style={{ wordBreak: 'break-all' }}>
            {serial ? <var className="notranslate">{sanitizeText(serial)}</var> : 'None'}
          </Text>
          {isRefunded && <Text ml={1}>(Refunded)</Text>}
        </Flex>
      </Flex>
      <Divider />
    </>
  );
};

export default SerialNumberRow;
